import * as React from 'react';
import './avatar.styles.css';
import type { AvatarProps, SVGRendererProps } from './type';

const SVGRenderer: React.FC<SVGRendererProps> = ({ svgString }) => {
  return <div dangerouslySetInnerHTML={{ __html: svgString }} />;
};

const Avatar = ({
  image = '',
  backgroundColor = '#456EFF',
  size = 64,
  borderRadius = 56,
  borderWidth = 3,
  borderColor = 'rgba(255, 255, 255, 0.20)',
  text = '',
  svg = ''
}: AvatarProps) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius,
        backgroundColor,
        backgroundImage: `url(${image})`,
        borderWidth,
        borderColor,
        borderStyle: 'solid',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      className="avatar-container">
      {text.length > 0 && image.length == 0 ? (
        <p className="avatar-text">{text}</p>
      ) : (
        svg && image.length == 0 && <SVGRenderer svgString={svg} />
      )}
    </div>
  );
};

export default Avatar;
